<template>
<div>
     <div class="current_nav">
      <img src="static/short_left.png"  /> {{$store.state.language === 'cn' ? '当前位置' : 'Location'}}：{{currentLocation}}
    </div>
     <div class="under_current_nav"></div>
    
</div>

</template>


<script>
export default {
  name: 'pageLocation',
  props:['currentLocation'],
  data () {
    return {
 
    }
  },
  methods:{
    

  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
 .current_nav{position:absolute;left:10%;margin-top:60px;}
 .under_current_nav{position:absolute;border-bottom:8px solid #8fa926;height:10px;margin-top:80px;width:80%;left:10%;}


</style>


// WEBPACK FOOTER //
// src/components/pageLocation.vue